import { z } from 'zod';
export const VerifyApplicationSchema = z.object({
    verificationCode: z.string().optional()
});
//# sourceMappingURL=verifyApplicationSchema.js.map